<template>
    <views v-if="!qrCode" class="verify">
        <nav-bar
            :title="moduleTitle"
            @click-left="onClickLeft">
        </nav-bar>
        <views class="form">
            <views class="form-text mt280">
                <input
                    v-model="form.code"
                    :placeholder="placeholderTitle"
                    type="number"
                    pattern="[0-9]*"
                    class="text-center">
            </views>
            <views class="form-button mt124 primary">
                <button @click="handleSubmit">校验</button>
            </views>
            <views v-if="isPublic" class="form-button mt20">
                <button @click="handleWxScanCode">{{ isPublic ? '扫码校验' : '扫码校验(测试使用)' }}</button>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import getLocation from '@/mixins/getLocation'
import api from '@/utils/api'
export default {
    name: 'Verify',
    mixins: [tools, getLocation],
    components: {
        NavBar
    },
    data() {
        return {
            form: {
                code: ''
            }
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        type() {
            return this.query.type
        },
        public() {
            return this.query.public
        },
        // 是否为明码验证 1: 明码验证 2:暗码校验
        isPublic() {
            return this.query.public === '1'
        },
        // 是否为产品防伪
        isVerify() {
            return this.query.type === 'verify'
        },
        // 是否为抽奖
        isPrize() {
            return this.query.type === 'prize'
        },
        // 是否为产品追溯
        isTrace() {
            return this.query.type === 'trace'
        },
        // 扫二维码描跳转而来
        qrCode() {
            return this.query.qrCode
        },
        moduleTitle() {
            return this.isPublic ? '明码校验' : '暗码校验'
        },
        placeholderTitle() {
            return this.isPublic ? '请输入包装袋二维码下方数字编码' : '请输入包装袋内12位纯数字编码'
        }
    },
    watch: {
        qrCode: {
            handler(val) {
                if (val) {
                    if (this.isVerify) this.handleVerify(val)
                    if (this.isPrize) this.handlePrize(val)
                    if (this.isTrace) this.handleTrace(val)
                }
            },
            immediate: true
        }
    },
    created() {
        // this.getLocation()
    },
    mounted() {
        document.body.addEventListener('focusout', this.scrollToTop)
        console.log(this.$store.getters.getPublicCode)
        if (this.$store.getters.getPublicCode) {
            this.loading('查询中...')
            // this.windowPush('/verify?type=verify&public=1')
            this.handleVerify(this.$store.getters.getPublicCode)
        }
    },
    destroyed() {
        document.body.removeEventListener('focusout', this.scrollToTop)
    },
    methods: {
        handleWxScanCode() {
            if (this.isPublic) {
                this.windowReplace(`/scan-code?type=${this.type}&public=${this.public}`)
            } else {
                this.windowReplace(`/scan-code?type=${this.type}&public=${this.public}&verify_record_id=${this.query.verify_record_id}&public_code=${this.query.public_code}`)
            }
        },
        onClickLeft() {
            this.push('/')
        },
        handleSubmit() {
            const { code } = this.form
            if (!code) return this.notify(`请输入${this.isPublic ? '明码' : '暗码'}`)
            if (this.isPublic && code.length !== 20) return this.notify('请输入正确的20位明码')
            if (!this.isPublic && code.length !== 12) return this.notify('请输入正确的12位暗码')
            if (this.isVerify) return this.handleVerify(code)
            if (this.isPrize) return this.handlePrize(code)
            if (this.isTrace) return this.handleTrace(code)
        },
        // 校验 - 产品防伪
        handleVerify(code) {
            let apiStr = ''
            const params = {}
            if (this.isPublic) {
                params.public_code = code
                apiStr = 'publicVerify'
            } else {
                params.public_code = this.query.public_code
                params.verify_record_id = this.query.verify_record_id
                params.secret_code = code
                apiStr = 'matchVerify'
            }
            api[apiStr](params).then((res) => {
                this.hideLoading()
                if (res.code === 0) {
                    params.success = true
                } else {
                    params.success = false
                }
                this.push({
                    path: '/verify-result',
                    query: {
                        type: this.query.type,
                        public: this.query.public,
                        ...params,
                        ...res.data
                    }
                })
            }).catch(() => {
                this.push('/')
            })
        },
        // 校验 - 抽奖
        handlePrize(code) {
            let apiStr = ''
            const params = {}
            if (this.isPublic) {
                params.public_code = code
                apiStr = 'publicVerifyForGeneral'
            } else {
                params.public_code = this.query.public_code
                params.verify_record_id = this.query.verify_record_id
                params.secret_code = code
                apiStr = 'matchVerifyForGeneral'
            }
            api[apiStr](params).then((res) => {
                if (this.isPublic) {
                    if (res.code === 0 && res.data) {
                        this.windowPush(`/verify?type=prize&public=2&public_code=${code}&verify_record_id=${res.data.verify_record_id}`)
                        this.form = {}
                    } else {
                        this.push(`/verify-result?type=prize&public=1&public_code=${code}&success=false`)
                    }
                } else {
                    if (res.code === 0) {
                        this.push(`/prize?public_code=${this.query.public_code}&secret_code=${code}`)
                    } else {
                        this.push(`/verify-result?type=prize&public=2&public_code=${params.public_code}&secret_code=${params.secret_code}&verify_record_id=${this.query.verify_record_id}&success=false`)
                    }
                }
            }).catch(() => {
                this.push('/')
            })
        },
        // 校验 - 追踪溯源
        handleTrace(code) {
            let apiStr = ''
            const params = {}
            if (this.isPublic) {
                params.public_code = code
                apiStr = 'publicVerifyForGeneral'
            } else {
                params.public_code = this.query.public_code
                params.verify_record_id = this.query.verify_record_id
                params.secret_code = code
                apiStr = 'matchTrace'
            }
            api[apiStr](params).then((res) => {
                if (this.isPublic) {
                    if (res.code === 0 && res.data) {
                        this.windowPush(`/verify?type=trace&public=2&public_code=${code}&verify_record_id=${res.data.verify_record_id}`)
                        this.form = {}
                    } else {
                        this.push(`/verify-result?type=trace&public=1&public_code=${code}&success=false`)
                    }
                } else {
                    const p = {}
                    if (res.code === 0) {
                        p.success = true
                    } else {
                        p.success = false
                        p.public_code = this.query.public_code
                        p.secret_code = code
                    }
                    this.push({
                        path: '/trace',
                        query: {
                            ...p,
                            ...res.data
                        }
                    })
                }
            }).catch((res) => {
                this.push(`/verify-result?type=trace&public=1&public_code=${code}&success=false`)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
